'use client';

import cx from 'classnames';

import { FormattedMessage } from '@flipster/i18n';

import styles from './passwordStatus.module.scss';

interface Props {
  isError: boolean;
  isValidLength: boolean;
  isValidLetter: boolean;
  isValidNumber: boolean;
  isValidSpecial: boolean;
}

export const PasswordStatus = ({ isError, isValidLength, isValidLetter, isValidNumber, isValidSpecial }: Props) => {
  return (
    <ul className={styles.wrapper}>
      <li className={cx({ [styles.active]: isValidLetter, [styles.error]: isError && !isValidLetter })}>
        <FormattedMessage id='Autogen_common.r251126.s_Letter' />
      </li>
      <li className={cx({ [styles.active]: isValidNumber, [styles.error]: isError && !isValidNumber })}>
        <FormattedMessage id='Autogen_common.r251126.s_Number' />
      </li>
      <li className={cx({ [styles.active]: isValidSpecial, [styles.error]: isError && !isValidSpecial })}>
        <FormattedMessage id='Autogen_common.r251126.s_Special_symbol' />
      </li>
      <li className={cx({ [styles.active]: isValidLength, [styles.error]: isError && !isValidLength })}>
        <FormattedMessage id='Autogen_common.r251126.s_Min_8_characters' />
      </li>
    </ul>
  );
};
